export default "__VITE_ASSET__CpbB2r5N__"